import { createClasses } from '@/theme/create-classes';

// ----------------------------------------------------------------------

export const iconifyClasses = {
  root: createClasses('iconify__root'),
};
